export const getStatusLabel = (status:string):string => {
  return status.toUpperCase().replace('_', ' ');
}

export const wait = (ms:number) => new Promise(resolve => setTimeout(resolve, ms));